import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { ReactComponent as BackIcon } from "../assets/back.svg";
import RecipeForm from "../components/RecipeForm";
import Header from "../components/Header";

const EditRecipePage = () => {
  let params = useParams();
  let navigate = useNavigate();

  // let recipe = recipes.find(recipe => recipe.id === Number(id))
  let [recipe, setRecipe] = useState(null);

  const [error, setError] = useState(null);

  useEffect(() => {
    let getRecipe = async () => {
      try {
        const response = await fetch("/api/recipes/" + params.id, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setRecipe(result);
      } catch (error) {
        setError(error);
        console.error("Failed to fetch recipe:", error);
        // navigate("/404");
      }
      return;
    };

    getRecipe();
  }, [navigate]);

  if (error) {
    return <p>Error: {error.message}</p>;
  }
  if (!recipe) {
    return <p>Couldn't find recipe data.</p>;
  }

  return (
    <div className="wrapper">
      <Header title="Edit a Recipe" />
      <div className="recipe">
        <div className="recipe-header">
          <h3>
            <Link className="back-button" to="/">
              <BackIcon />
            </Link>
          </h3>
        </div>
        <RecipeForm initValues={recipe} />
      </div>
    </div>
  );
};

export default EditRecipePage;
